export const ITEM_SIZE = 34;